import React from 'react';
import { Link } from 'react-router-dom';
import '../scss/card.scss';

function Card(props) {
  return (
    <div className="link-card text-center col-12 col-md-6">
      <Link to={props.url}>
        <div className="card-content">
          <div className="card-head">
            <h3>{props.displayText}</h3>
          </div>
          <div className="card-button">
            <button className="button" type="button">{props.buttonText}</button>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default Card;
